import React, { useState, useEffect } from 'react';
import { TextareaItem, Button, List, Modal } from 'antd-mobile';
import { Radios, Error, TitleDescriptions } from '../components';
import Permission from '../components/Permission';

import { AclKeys } from '../utils/permissions';
import * as Api from "../../../api/usms";
import { UsmsAuditStatus, UsmsStatus, Purpose } from '../utils/const';

import '../index.css';

function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function TemplateAudit(props) {

  const { info, fetchBack, AlertModalPanel } = props;

  const [status, setStatus] = useState("AuditSuccess");
  const [content, setContent] = useState();
  const [auditTemplates, setAuditTemplates] = useState([]);
  const [showAuditTemplate, setShowAuditTemplate] = useState(false);
  const [showAllAuditTemplate, setShowAllAuditTemplate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [alertModalShow, setAlertModalShow] = useState(false);

  useEffect(() => { getAuditTemplate() }, []);

  const onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  }

  const AlertPanelShow = () => {
    if (!AlertModalPanel) {
      return '';
    }
    return <Modal
      visible={alertModalShow}
      transparent
      maskClosable={false}
      onClose={() => {
        setAlertModalShow(false);
      }}
      title="请确认审核模板信息"
      footer={[
        {text: '取消', onPress: () => {
          setAlertModalShow(false);
        }},
        { text: '确认审核', onPress: () => {
          handleAudit();
        }},
      ]}
      wrapProps={{ onTouchStart: onWrapTouchStart }}
      afterClose={() => { }}
    >
      <AlertModalPanel />
    </Modal>
  }

  const handleAudit = () => {
    const data = {
      TemplateCategory: info.TemplateCategory,
      TemplateIds: [info.TemplateId],
      AuditStatus: status,
      AuditContent: content
    }
    setAlertModalShow(false);

    setLoading(true);
    Api.UpdateUSMSTemplateStatus(data).then(res => {
      setLoading(false);
      fetchBack();
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const getAuditTemplate = () => {
    const data = {
      Enable: "Enable",
      Limit: 1000,
      Offset: 0
    }
    Api.DescribeAuditTemplate(data).then(res => {
      setAuditTemplates(res)
    })
  }

  const AuditTemplate = (props) => {
    // 根据当前签名信息过滤审核模板
    const currentAuditTemplates = auditTemplates.filter(item =>
      (item.TemplateType === info.Purpose && item.StatusType === props.status));
    const showTemplates = showAllAuditTemplate ? auditTemplates : currentAuditTemplates;
    if (auditTemplates.length === 0) {
      return <div className="text-small">没有审核内容模板</div>
    }
    return <div>
      {showTemplates.length > 0 ?
        showTemplates.map((item, index) => <List.Item
          arrow="horizontal"
          onClick={() => setContent(String(item.Content))}
          key={index}>
          <TitleDescriptions
            title={<div className="text-default overflow-pre">{item.Content}</div>}
            descriptions={[
              UsmsStatus[item.StatusType], Purpose[item.TemplateType],
              ...item.ContentType
            ]} />
        </List.Item>) :
        <div className="text-small">当前模板类型没有审核内容模板</div>}
      <div
        className="a-blue text-small"
        onClick={() => setShowAllAuditTemplate(!showAllAuditTemplate)}>
        {showAllAuditTemplate ? "当前模板" : "全部模版"}
      </div>
    </div>
  }

  return (
    <Permission aclKey={AclKeys.TemplateAudit}>
      <div>
        <span>结果：</span>
        <Radios
          value={status}
          onChange={value => setStatus(value)}
          options={Object.keys(UsmsAuditStatus).map(item => ({ label: UsmsAuditStatus[item], value: item }))} />
      </div>
      <div>
        <span>反馈：</span>
        <TextareaItem autoHeight rows={2} className="text-default" value={content} onChange={value => setContent(value)} />
      </div>
      <div className="a-blue text-small" onClick={() => setShowAuditTemplate(true)}>常见审核内容模版</div>
      {showAuditTemplate ? <AuditTemplate status={status} /> : null}
      <Button
        type="primary"
        style={{ marginTop: '10px' }}
        onClick={() => {
          if (!AlertModalPanel) {
            handleAudit();
            return;
          }

          setAlertModalShow(true)
        }}
        loading={loading}>审核</Button>
      {errorMessage ? <Error message={errorMessage} /> : null}

      <AlertPanelShow />
    </Permission>
  )
}
export default TemplateAudit